import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetAvailableFeaturesRequest,
  DefaultApiUpdateMerchantOrganizationCommentRequest,
  DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest,
  DefaultApiUpdateOrganizationRequest,
  DefaultApiAgreeToAgreementRequestRequest,
  DefaultApiGetAgreementRequestsRequest,
  DefaultApiDisagreeToAgreementRequestRequest,
  DefaultApiCreatePastDealsRequest,
  DefaultApiGetCardTransactionDetailsRequest,
  DefaultApiGetMonthlyCardBillRequest,
  DefaultApiGetCanRequestSendingCardRequest,
  DefaultApiGetOrgAccountStateRequest,
  DefaultApiGetOrganizationRequest,
  DefaultApiGetMerchantOrgBlockListRequest,
  DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest,
  DefaultApiSendOrganizationIdentityVerificationRequest,
  DefaultApiUpdateUserPrivilegeRequest,
  DefaultApiGetOrganizationPaymentsRequest,
  DefaultApiBulkUpdateOrganizationUserPrivilegesRequest,
  DefaultApiGetOrganizationsBillsRequest,
  DefaultApiPostAlliancesGcpApplicationsRequest,
  DefaultApiGetInvoiceListRequest,
  DefaultApiPostAlliancesGwsApplicationsRequest,
  DefaultApiSearchOrganizationsRequest,
  DefaultApiDepositGuaranteeMoneyBalanceRequest,
  DefaultApiGetOrganizationCardsExtendedRequest,
  DefaultApiGetIssuableStatusRequest,
  DefaultApiRequestSendingMetalCardRequest,
  DefaultApiGetRewardPointTransactionsRequest,
  DefaultApiGetRewardPointBalanceRequest,
  DefaultApiGetAnnualFeesEligibilityRequest,
  DefaultApiGenerateAnnualFeesInvoiceRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getOrganizationMe = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).getOrganizationMe()
}

export const getAvailableFeatures = async (
  instance: AxiosInstance,
  params: DefaultApiGetAvailableFeaturesRequest
) => {
  return await userApiDefaultApiFactory(instance).getAvailableFeatures(params)
}

export const getMerchantOrganizationUserAccountYearMonthSummary = async (
  instance: AxiosInstance,
  params: DefaultApiGetMerchantOrganizationUserAccountYearMonthSummaryRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getMerchantOrganizationUserAccountYearMonthSummary(params)
}

export const updateMerchantOrganizationComment = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateMerchantOrganizationCommentRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).updateMerchantOrganizationComment(params)
}

export const updateOrganizationInfo = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateOrganizationRequest
) => {
  return await userApiDefaultApiFactory(instance).updateOrganization(params)
}

export const agreeToAgreementRequest = async (
  instance: AxiosInstance,
  params: DefaultApiAgreeToAgreementRequestRequest
) => {
  return await userApiDefaultApiFactory(instance).agreeToAgreementRequest(
    params
  )
}

export const getAgreementRequests = async (
  instance: AxiosInstance,
  params: DefaultApiGetAgreementRequestsRequest
) => {
  return await userApiDefaultApiFactory(instance).getAgreementRequests(params)
}

export const disagreeToAgreementRequest = async (
  instance: AxiosInstance,
  params: DefaultApiDisagreeToAgreementRequestRequest
) => {
  return await userApiDefaultApiFactory(instance).disagreeToAgreementRequest(
    params
  )
}

export const createPastDeals = async (
  instance: AxiosInstance,
  params: DefaultApiCreatePastDealsRequest
) => {
  return await userApiDefaultApiFactory(instance).createPastDeals(params)
}

export const getCardTransactionDetails = async (
  instance: AxiosInstance,
  params: DefaultApiGetCardTransactionDetailsRequest
) => {
  return await userApiDefaultApiFactory(instance).getCardTransactionDetails(
    params
  )
}

export const getMonthlyCardBill = async (
  instance: AxiosInstance,
  params: DefaultApiGetMonthlyCardBillRequest
) => {
  return await userApiDefaultApiFactory(instance).getMonthlyCardBill(params)
}

export const getCanRequestSendingCard = async (
  instance: AxiosInstance,
  params: DefaultApiGetCanRequestSendingCardRequest
) => {
  return await userApiDefaultApiFactory(instance).getCanRequestSendingCard(
    params
  )
}

export const getOrgAccountState = async (
  instance: AxiosInstance,
  params: DefaultApiGetOrgAccountStateRequest
) => {
  return await userApiDefaultApiFactory(instance).getOrgAccountState(params)
}

export const getOrganization = async (
  instance: AxiosInstance,
  params: DefaultApiGetOrganizationRequest
) => {
  return await userApiDefaultApiFactory(instance).getOrganization(params)
}

export const getMerchantOrgBlockList = async (
  instance: AxiosInstance,
  params: DefaultApiGetMerchantOrgBlockListRequest
) => {
  return await userApiDefaultApiFactory(instance).getMerchantOrgBlockList(
    params
  )
}

export const postBulkAdditionMerchantOrgBlockLists = async (
  instance: AxiosInstance,
  params: DefaultApiPostBulkAdditionMerchantOrgBlockListsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).postBulkAdditionMerchantOrgBlockLists(params)
}

export const sendOrganizationIdentityVerification = async (
  instance: AxiosInstance,
  params: DefaultApiSendOrganizationIdentityVerificationRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).sendOrganizationIdentityVerification(params)
}

export const updateUserPrivilege = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateUserPrivilegeRequest
) => {
  return await userApiDefaultApiFactory(instance).updateUserPrivilege(params)
}

export const searchOrganizations = async (
  instance: AxiosInstance,
  params: DefaultApiSearchOrganizationsRequest
) => {
  return await userApiDefaultApiFactory(instance).searchOrganizations(params)
}

export const getOrganizationPayments = async (
  instance: AxiosInstance,
  params: DefaultApiGetOrganizationPaymentsRequest
) => {
  return await userApiDefaultApiFactory(instance).getOrganizationPayments(
    params
  )
}

export const updateOrganizationUserPrivileges = async (
  instance: AxiosInstance,
  params: DefaultApiBulkUpdateOrganizationUserPrivilegesRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).bulkUpdateOrganizationUserPrivileges(params)
}

export const getOrganizationsBills = async (
  instance: AxiosInstance,
  params: DefaultApiGetOrganizationsBillsRequest
) => {
  return await userApiDefaultApiFactory(instance).getOrganizationsBills(params)
}

export const postAlliancesGcpApplications = async (
  instance: AxiosInstance,
  params: DefaultApiPostAlliancesGcpApplicationsRequest
) => {
  return await userApiDefaultApiFactory(instance).postAlliancesGcpApplications(
    params
  )
}

export const getInvoiceList = async (
  instance: AxiosInstance,
  params: DefaultApiGetInvoiceListRequest
) => {
  return await userApiDefaultApiFactory(instance).getInvoiceList(params)
}

export const postAlliancesGwsApplications = async (
  instance: AxiosInstance,
  params: DefaultApiPostAlliancesGwsApplicationsRequest
) => {
  return await userApiDefaultApiFactory(instance).postAlliancesGwsApplications(
    params
  )
}

export const depositGuaranteeMoneyBalance = async (
  instance: AxiosInstance,
  params: DefaultApiDepositGuaranteeMoneyBalanceRequest
) => {
  return await userApiDefaultApiFactory(instance).depositGuaranteeMoneyBalance(
    params
  )
}

export const getOrganizationCardsExtended = async (
  instance: AxiosInstance,
  params: DefaultApiGetOrganizationCardsExtendedRequest
) => {
  return await userApiDefaultApiFactory(instance).getOrganizationCardsExtended(
    params
  )
}

export const getIssuableStatus = async (
  instance: AxiosInstance,
  params: DefaultApiGetIssuableStatusRequest
) => {
  return await userApiDefaultApiFactory(instance).getIssuableStatus(
    params
  )
}

export const requestSendingMetalCard = async (
  instance: AxiosInstance,
  params: DefaultApiRequestSendingMetalCardRequest
) => {
  return await userApiDefaultApiFactory(instance).requestSendingMetalCard(
    params
  )
}

export const getRewardPointTransactions = async (
  instance: AxiosInstance,
  params: DefaultApiGetRewardPointTransactionsRequest
) => {
  return await userApiDefaultApiFactory(instance).getRewardPointTransactions(
    params
  )
}

export const getRewardPointBalance = async (
  instance: AxiosInstance,
  params: DefaultApiGetRewardPointBalanceRequest
) => {
  return await userApiDefaultApiFactory(instance).getRewardPointBalance(
    params
  )
}

export const getAnnualFeesEligibility = async (
  instance: AxiosInstance,
  params: DefaultApiGetAnnualFeesEligibilityRequest
) => {
  return await userApiDefaultApiFactory(instance).getAnnualFeesEligibility(
    params
  )
}

export const generateAnnualFeesInvoice = async (
  instance: AxiosInstance,
  params: DefaultApiGenerateAnnualFeesInvoiceRequest
) => {
  return await userApiDefaultApiFactory(instance).generateAnnualFeesInvoice(
    params,
    {
      responseType: 'blob'
    }
  )
}

// Do Not Remove this line ===@import api client===
